import type { RouteObject } from 'react-router-dom';

/**
 * Public pages for visitors who are not signed in, mounted OUTSIDE the signed-in shell by
 * router.tsx. `/` shows the landing page to a signed-out visitor (RequireAuth renders it
 * in place of the sign-in redirect); `/welcome` always shows it.
 */
export const landingRoutes: RouteObject[] = [
  { path: 'welcome', lazy: async () => ({ Component: (await import('./LandingPage')).LandingPage }) },
];
